<template>
  <div 
    v-if="isShowing" 
    ref="exportProcessRef" 
    class="process"
    :class="rightCss"
    @mousedown="dragMouseDown"
    @mouseup="handleMouseUp"
  >
    <div class="process__head">
      <span class="process__head__text">
        {{ headText }}
      </span>
      <div
        class="process__head__icon icon20"
        :class="[isOpen ? 'ic_process-hide' : 'ic_process-expand']"
        @click.prevent="toggleProcessBlock"
      />
    </div>
    <div v-if="isOpen" class="process__body">
      <MsExportProcessItem
        v-for="(item, index) in lstExportProcess"
        :id="item.Id"
        :key="index"
        :name="item.Name"
        :status="item.Status"
        @remove="removeHandler"
      />
    </div>
  </div>
</template>

<script setup>
import MsExportProcessItem from './MsExportProcessItem.vue';
import { ref, computed, inject } from 'vue';
import { I18nInjectionKey } from 'vue-i18n';
import { ModuleExport } from '@/stores/moduleConst';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import { MSEnum } from '@/commons/enumeration';

const PADDING_X = 50;
const PADDING_Y = 24;

const { t } = inject(I18nInjectionKey);
const store = useStore();
const route = useRoute();
const router = useRouter();

const lstExportProcess = computed(() => {
  let result = [];
  let processes = _.cloneDeep(store.state[ModuleExport]);
  if (processes && processes.hasOwnProperty('lstNameExport')) {
    for (let property in processes.lstNameExport) {
      let exportInfo = processes.lstNameExport[property];
      if (exportInfo) {
        result.push({
          Id: property,
          Name: exportInfo.NameFileClient,
          Status: exportInfo.Status,
        });
      }
    }
  }

  //Nếu chỉ có 1 file xuất khẩu thì mở luôn
  if(result.length == 1) {
    isOpen.value = true;
  }
  return result;
});
const isOpen = ref(false);
const exportProcessRef = ref(null);
const oldPosition = ref({
  left: 0,
  top: 0,
})
const pos = ref({
  pos1: 0,
  pos2: 0,
  pos3: 0,
  pos4: 0,
})

/**
 * tiêu đề tiến trình
 * created by lkphuc 13.03.2023
 */
const headText = computed(() => {
  return `${lstExportProcess.value.length} ${t('i18nCommon.ExportProcessing')}`;
});

/**
 * nếu có tiến trình thì hiển thị
 * ngược lại ẩn block đi
 * created by lkphuc 13.03.2023
 */
const isShowing = computed(() => {
  return lstExportProcess.value.length > 0 ? true : false;
});

/**
 * nếu là màn hình tổng quan thì right = 100
 * ngược lại right = 32
 * created by lkphuc 13.03.2023
 */
const rightCss = computed(() => {
  if (route.fullPath == `/${MSEnum.AppCode}/dashboard`) {
    return 'r-100';
  }
  return '';
});

/**
 * ẩn hiện thông tin chi tiết các tiến trình
 * created by lkphuc 13.03.2023
 */
const toggleProcessBlock = () => {
  isOpen.value = !isOpen.value;
};

/**
 * xử lý sự kiện khi người dùng remove một tiến trình
 * created by lkphuc 13.03.2023
 */
const removeHandler = (id) => {
  store.commit(`${ModuleExport}/removeExportProcess`, id);
};

/**
 * Xử lý do chuyển chuột
 * @param {object} e event object
 */
const elementDrag = (e) => {
  e = e || window.event;
  e.preventDefault();
  // calculate the new cursor position:
  pos.value.pos1 = pos.value.pos3 - e.clientX;
  pos.value.pos2 = pos.value.pos4 - e.clientY;
  pos.value.pos3 = e.clientX;
  pos.value.pos4 = e.clientY;
  // set the element's new position:
  exportProcessRef.value.style.top = (exportProcessRef.value.offsetTop - pos.value.pos2) + "px";
  exportProcessRef.value.style.left = (exportProcessRef.value.offsetLeft - pos.value.pos1) + "px";
  exportProcessRef.value.style.right = 'auto';
  exportProcessRef.value.style.bottom = 'auto';
}

/**
 * Xử lý nhấn chuột
 * @param {object} e event
 */
const dragMouseDown = (e) => {
  e = e || window.event;
  e.preventDefault();
  const exportProcessRect = exportProcessRef.value.getBoundingClientRect();
  oldPosition.value.left = exportProcessRect.left
  oldPosition.value.top = exportProcessRect.top
  // get the mouse cursor position at startup:
  pos.value.pos3 = e.clientX;
  pos.value.pos4 = e.clientY;
  // call a function whenever the cursor moves:
  document.addEventListener('mousemove', elementDrag);
  if (exportProcessRef.value) 
    exportProcessRef.value.style.transition = "width 0.3s ease, height 0.3s ease";
}

/**
 * Xử lý thả chuột
 * @author: BMThang(03/04/2023)
 */
const handleMouseUp = () => {
  document.removeEventListener('mousemove', elementDrag);
  const exportProcessRect = exportProcessRef.value.getBoundingClientRect();
  if (pos.value.pos3 < (window.innerWidth / 2)) {
    exportProcessRef.value.style.left = `${PADDING_X}px`;
  } else {
    exportProcessRef.value.style.left = `${window.innerWidth - PADDING_X - exportProcessRect.width}px`;
  }
  if (exportProcessRect.top < PADDING_Y) {
    exportProcessRef.value.style.top = `${PADDING_Y}px`;
  } else if (exportProcessRect.top + exportProcessRect.height > window.innerHeight - PADDING_Y) {
    exportProcessRef.value.style.top = `${window.innerHeight - PADDING_Y - exportProcessRect.height}px`;
  }
  
  exportProcessRef.value.style.transition = "0.3s ease-in-out left"
}

</script>

<style lang="scss" scoped>
@import '@/assets/scss/components/MsExportProcess.scss';
</style>